export const getMyAccountUrl = (path) => {
  const isProduction = window.location.host === "www.asos.com";
  const myAsosDomain = isProduction
    ? "https://my.asos.com"
    : "https://my.asosservices.com";

  return new URL(`${myAsosDomain}${path ? path : ""}`);
};
